import React, { useState, useRef, useEffect } from 'react';
import Bulb from 'common/components/svgs/Bulb';
import Close from 'common/components/svgs/Close';
import NoticeCard from './noticeCard';

const Notice = props => {
  const { t, button, content = [] } = props;

  const [isOpen, setIsOpen] = useState(false);
  const contentRef = useRef(null);
  const triggerRef = useRef(null);
  const [contentStyle, setContentStyle] = useState({});
  const [arrowPosition, setArrowPosition] = useState('center');

  useEffect(() => {
    if (isOpen && contentRef.current && triggerRef.current) {
      const contentRect = contentRef.current.getBoundingClientRect();
      const triggerRect = triggerRef.current.getBoundingClientRect();
      const windowWidth = window.innerWidth;
      const spaceRight = windowWidth - triggerRect.right;
      if (spaceRight < contentRect.width) {
        setContentStyle({
          right: 0,
          left: 'auto',
        });
        setArrowPosition('right');
      } else {
        setContentStyle({
          left: '50%',
          transform: 'translateX(-50%)',
        });
        setArrowPosition('center');
      }
    }
  }, [isOpen]);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <div className="notice-wrapper" style={{ position: 'relative', display: 'inline-block' }}>
      <div className="notice__trigger" onClick={handleToggle} ref={triggerRef}>
        <Bulb />
        <span className="notice__hint">{t(button)}</span>
      </div>
      {isOpen && (
        <div>
          <div className={`notice__arrow notice__arrow--${arrowPosition}`} />
          <div className="notice__content" ref={contentRef} style={contentStyle}>
            {content.map((item, index) => (
              <NoticeCard key={index} title={t(item.title)} description={t(item.description)} />
            ))}
          </div>
          <div className="notice__close" onClick={handleClose}>
            <Close />
          </div>
        </div>
      )}
    </div>
  );
};

export default Notice;
